module.exports = __webpack_public_path__ + "static/media/rainbow.2f2c9762.png";